module.exports = __webpack_public_path__ + "img/violet_081.618c9f94.png";